module.exports = __webpack_public_path__ + "static/img/fcBg01.43f816a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fcBg01.png
// module id = 7tY5
// module chunks = 101